export enum casType {
  dlic = 'dlic',
  transfer = 'transfer',
}
